/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 04/04/18
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

class InformationModal extends Component {
  render() {
    const { openInformationModal, handleClose } = this.props;

    return (
      <Modal show={openInformationModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Outlet Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            This feature only available for paid subscription. Please call
            1500970 for more information
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const { openInformationModal } = state.setting.paymentMethod;
  return {
    openInformationModal,
  };
}

export default connect(mapStateToProps)(InformationModal);
